<template>
  <div id="mention-modal" :style="{ bottom, left }">
    <MemberList
      ref="memberList"
      :isComment="true"
      :projectId="projectId"
      :visible.sync="visible"
      :memberList="projectMember"
      @handleChos="handleChos"
    ></MemberList>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import MemberList from '@/views/customKeyPage/components/Object/Executor/memberList'

export default {
  name: 'MentionModal',
  props: {
    // 项目id
    projectId: {
      type: Number,
      default: 0
    }
  },
  components: {
    MemberList
    // Members
  },
  data() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      height: '200px',
      loading: false,
      visible: false,
      memberList: []
    }
  },
  computed: {
    ...mapState('project/project', {
      projectMember: state => {
        let arr = []
        state.newMember.map(res => {
          arr.push(...res.children)
        })
        return arr
      }
    }),
  },
  mounted() {
    this.handlePosition() // 浮窗定位
  },
  methods: {
    // 选中成员
    handleChos(arr) {
      // console.log(arr, 111)
      for (let i = 0, len = arr.length; i < len; i++) {
        this.$emit('insertMention', arr[i].uid, arr[i].realname)
      }
    },
    // 搜索成员
    handleSearchMember(keywords) {
      this.getProjectMembers(keywords)
    },
    // 浮窗定位
    handlePosition() {
      // 获取光标位置
      const domSelection = document.getSelection()
      const domRange = domSelection?.getRangeAt(0)
      if (domRange == null) return
      const rect = domRange.getBoundingClientRect()
      // console.log(rect, 111)

      // 获取编辑器的位置
      const editorRect = document.querySelector('.task-dialog').getBoundingClientRect()

      // 获取名单展示的真实位置
      const _trueRect = {
        top: rect.top - editorRect.top,
        left: rect.left - editorRect.left
      }
      // 定位 modal
      // this.top = `${ _trueRect.top - 560 <= -96 ? -96 : _trueRect.top - 580 }px`
      this.bottom = `${ window.innerHeight - rect.y - 200 }px` // 浏览器高度减去光标的y轴再减去偏差200
      // this.top = `${ 20 }px`
      // this.bottom = `${ 20 }px`
      this.left = `${ _trueRect.left + 5 }px`
      // focus input
      // console.log(this.$refs.memberList, this.$refs.memberList.$el.querySelector('input'), 111)
      this.$refs.memberList.$el.querySelector('input').focus()
    }
  },
}
</script>

<style lang="scss" scoped>
#mention-modal {
  position: fixed;
  z-index: 99;
  background-color: #fff;
  box-shadow: 0px 4px 16px 0px rgba(13, 37, 60, .24);
  border-radius: 4px;
  width: 314px;
}
</style>
